import { IBusinessEntity } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { useQuery } from '@tanstack/react-query';
import { useApiScope } from '../scope';
import { businessEntityKeys } from './keys';

const getBusinessEntity = async (
  businessEntityId: number,
  options: BusinessEntityQueryOptions | undefined,
  shareToken: string | undefined
) => {
  const queryParams = new URLSearchParams();
  if (options?.includeOnboardingInformation) {
    queryParams.append('includeOnboardingInformation', 'true');
  }

  const queryString = queryParams.toString();
  const url = `business-entities/${businessEntityId}${queryString ? `?${queryString}` : ''}`;

  const response = await fetcher(url, {
    method: 'GET',
    shareToken,
  });

  if (!response.ok) throw new Error('Failed to fetch business entity');

  return (await response.json()) as IBusinessEntity;
};

type BusinessEntityQueryOptions = {
  includeOnboardingInformation: boolean;
};

const useBusinessEntity = (
  businessEntityId: number,
  options?: BusinessEntityQueryOptions
) => {
  const { shareToken } = useApiScope();

  return useQuery({
    queryKey: [
      businessEntityKeys.FETCH_BUSINESS_ENTITY,
      businessEntityId,
      options?.includeOnboardingInformation,
      shareToken,
    ],
    queryFn: () => getBusinessEntity(businessEntityId, options, shareToken),
    enabled: !!businessEntityId,
  });
};

export { useBusinessEntity };
